var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 124,
    viewBox: "0 0 201 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_165_168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.07747 90.1341L74.923 122.761V33.4927L9.07747 0.865608C4.06454 -1.61219 0 1.40869 0 7.62863V74.3848C0 80.6047 4.06454 87.6563 9.07747 90.1341Z",
    fill: "url(#paint0_linear_165_168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0639 91.5596V122.311C26.0639 123.975 28.2062 124.636 29.1377 123.262L44.8116 100.223L26.0639 91.5596Z",
    fill: "url(#paint1_linear_165_168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.923 32.6271L126.085 0V89.2684L191.931 121.896C196.944 124.382 201.008 121.352 201.008 115.141V48.3764C201.008 42.1564 196.944 35.1049 191.931 32.6271H191.923Z",
    fill: "url(#paint2_linear_165_168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.756 91.5596V122.311C166.756 123.975 164.614 124.636 163.682 123.262L148.009 100.223L166.756 91.5596Z",
    fill: "url(#paint3_linear_165_168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.085 89.2684L74.9146 122.761V33.4926L126.085 0V89.2684Z",
    fill: "#85005F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2668 75.403C28.5703 72.5179 21.4997 63.0819 21.4997 54.3672C21.4997 45.6525 28.5703 40.9175 37.2668 43.8026C40.5438 44.8888 43.6938 46.9423 46.3696 49.7256L43.4652 52.8737C41.6446 50.973 39.5023 49.5813 37.2668 48.8346C31.3478 46.8659 26.5296 50.099 26.5296 56.0304C26.5296 61.9618 31.3478 68.3854 37.2668 70.3541C39.4853 71.0923 41.6107 71.1263 43.4228 70.4559L46.3104 75.5473C43.643 76.5316 40.5184 76.4807 37.2668 75.403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6007 64.7238C43.6301 62.9991 43.3357 59.309 40.9431 56.4818C38.5505 53.6546 34.9657 52.7609 32.9362 54.4856C30.9068 56.2103 31.2012 59.9004 33.5938 62.7276C35.9864 65.5548 39.5712 66.4486 41.6007 64.7238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.838 45.7628C168.534 48.6479 175.605 58.0839 175.605 66.7986C175.605 75.5133 168.534 80.2483 159.838 77.3632C156.561 76.277 153.411 74.2235 150.735 71.4402L153.64 68.2921C155.46 70.1928 157.603 71.5845 159.838 72.3312C165.757 74.2999 170.575 71.0669 170.575 65.1354C170.575 59.204 165.757 52.7804 159.838 50.8117C157.619 50.0735 155.494 50.0396 153.682 50.7099L150.794 45.6186C153.462 44.6342 156.586 44.6851 159.838 45.7628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.167 66.6766C166.196 64.9519 165.902 61.2618 163.509 58.4346C161.117 55.6074 157.532 54.7137 155.502 56.4384C153.473 58.1631 153.767 61.8532 156.16 64.6804C158.553 67.5076 162.137 68.4014 164.167 66.6766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1196 61.3848L74.9146 78.1269L126.085 44.6342L156.739 59.8234",
    stroke: "white",
    strokeWidth: 5.47,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_165_168",
    x1: 78.361,
    y1: 101.31,
    x2: 10.3906,
    y2: 28.8747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E0A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_165_168",
    x1: 50.358,
    y1: 127.581,
    x2: -17.6039,
    y2: 55.1461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E0A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_165_168",
    x1: 137.449,
    y1: 23.3014,
    x2: 197.577,
    y2: 122.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E6007E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD1C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_165_168",
    x1: 119.879,
    y1: 33.9933,
    x2: 180.015,
    y2: 132.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E6007E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD1C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 201,
    height: 124,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.77924f1e0a2cacb36462407f817bff13.svg";
export { ForwardRef as ReactComponent };